import styled from 'styled-components';

import Icon from 'components/Icon';

export const LikeContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: ${props =>
    props.active ? props.theme.color.primary : props.theme.color.wfGrey600};
`;

export const HeartIcon = styled(Icon)`
  cursor: pointer;
  transition: transform 100ms ease-in-out 0s;
  margin-right: ${props =>
    props.size === 'medium'
      ? props.theme.spacing.small
      : props.theme.spacing.xsmall};
  margin-left: auto;
  &:hover {
    transform: scale(1.3);
    color: ${props =>
      props.active ? props.theme.color.wfOrange : props.theme.color.primary};
  }
`;

export const LikesCount = styled.span`
  color: ${props => props.theme.color.wfGrey600};
  margin-right: 0.5rem;
`;
